module.exports = __webpack_public_path__ + "img/BeiOpaGibtsEis.834073e2.svg";